var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg95(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 3H10.5M4.5 5.5V8.5M7.5 5.5V8.5M2 3L2.5 10C2.5 10.552 2.948 11 3.5 11H8.5C9.052 11 9.5 10.552 9.5 10L10 3M4 3V1.5C4 1.224 4.224 1 4.5 1H7.5C7.776 1 8 1.224 8 1.5V3",
    stroke: "#C10007",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg95);
export default __webpack_public_path__ + "static/media/svg95.8b16b7cfeff1a815c3828a63c7d4952f.svg";
export { ForwardRef as ReactComponent };